import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiDownload } from 'react-icons/fi';

/**
 * Renders the store availability for a product that ships across several stores.
 * Each store is a live "Available on X" button when it has an href, or a
 * greyed-out "Coming soon" chip when it does not. This lets a title go up as
 * "coming soon" everywhere and flip each store to a real link the moment its
 * page is live, by editing only the catalog entry.
 */
const StoreButtons = ({ stores = [], accentColor = 'bg-accent-blue', className = '' }) => {
  if (!stores.length) return null;
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {stores.map((s) =>
        s.href ? (
          <a
            key={s.id}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`btn-primary ${accentColor} text-white px-6 py-3 decoration-transparent`}
          >
            <SafeIcon icon={FiDownload} className="w-5 h-5" />
            <div className="flex flex-col items-start leading-none">
              <span className="text-[10px] uppercase tracking-wider opacity-80">Available on</span>
              <span className="text-sm font-semibold">{s.name}</span>
            </div>
          </a>
        ) : (
          <div
            key={s.id}
            className="flex items-center gap-2 rounded-md border border-border bg-card px-6 py-3 text-muted"
            title="Coming soon"
          >
            <SafeIcon icon={FiClock} className="w-5 h-5" />
            <div className="flex flex-col items-start leading-none">
              <span className="text-[10px] uppercase tracking-wider opacity-70">Coming soon</span>
              <span className="text-sm font-semibold">{s.name}</span>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default StoreButtons;
